import React, { useEffect, useState } from 'react';
import { getThemeComponent } from '@/utils/themeImports';
import { specificThemeRender } from '@/utils/specificThemeRender';
import { useSSRSelector } from '../../redux';
import moment from 'moment';

const BlogPage = (props) => {
  const { storeInfo, catalogCategories } = useSSRSelector((state) => ({
    storeInfo: state.storeReducer.store,
    catalogCategories: state.catalogReducer.categories,
  }));

  const [blogData, setBlogData] = useState({});

  useEffect(() => {
    setBlogData(props?._addPage);
  }, [props?._addPage]);

  function BlogTitleAndAuthorDetails() {
    return (
      <section className="tw-mb-40 tw-mt-40 tw-flex tw-flex-col">
        <h1 className="tw-m-0 tw-mb-16 tw-text-[#000]">{blogData?.page_name}</h1>
        <div className="tw-flex tw-flex-col tw-gap-8">
          {!!blogData?.author && (
            <span className="tw-m-0 tw-text-sm tw-font-bold tw-text-[#555D70]">
              By {blogData.author}
            </span>
          )}
          <div className="tw-flex tw-items-center tw-gap-8 tw-text-12 tw-font-normal tw-text-[#555D70]">
            {!!blogData?.updated_at && (
              <span>{moment(blogData?.updated_at).format('D MMM YYYY')}</span>
            )}
            {!!blogData?.reading_time && (
              <>
                <div className="tw-size-[4px] tw-rounded-full tw-bg-[#555D70]"></div>
                <span>
                  {blogData?.reading_time} minute{blogData?.reading_time > 1 ? 's' : ''}{' '}
                  read
                </span>
              </>
            )}
          </div>
        </div>
      </section>
    );
  }

  function BlogHtmlContent({ htmlData }) {
    const [processedHTML, setProcessedHTML] = useState('');

    useEffect(() => {
      if (htmlData) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlData, 'text/html');

        doc.querySelectorAll('img').forEach((img) => {
          const getAttr = (attr, fallback = '') => img.getAttribute(attr) || fallback;
          const {
            src,
            alt,
            class: className,
            title: caption,
            href,
            linkTarget,
          } = {
            src: getAttr('src'),
            alt: getAttr('alt'),
            class: getAttr('class'),
            title: getAttr('title'),
            href: getAttr('data-href'),
            linkTarget: getAttr('data-href-target') === 'true' ? '_blank' : '_self',
          };

          const imgTag = `<img src="${src}" alt="${alt}" class="${className}">`;
          const figcaptionTag = caption ? `<figcaption>${caption}</figcaption>` : '';
          const wrappedImg = href
            ? `<a href="${href}" target="${linkTarget}" rel="${linkTarget === '_blank' ? 'noopener noreferrer' : ''}">${imgTag}</a>`
            : imgTag;

          const figure = document.createElement('figure');
          figure.innerHTML = `${wrappedImg}${figcaptionTag}`;
          img.replaceWith(figure);
        });

        setProcessedHTML(doc.body.innerHTML);
      } else {
        setProcessedHTML('');
      }
    }, [htmlData]);

    return (
      <div className="tw-mt-40 tw-w-[100%] tw-text-[16px] tw-font-normal tw-leading-[1.7] tw-text-[#242424]">
        <div className="">
          <p
            dangerouslySetInnerHTML={{
              __html: processedHTML,
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {specificThemeRender(storeInfo)?.components?.Header?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, {
          storeData: props.storeInfo,
          categories: catalogCategories || [],
          ...layout,
        });
      })}
      <div className="ai__blog__container tw-m-auto tw-my-0 tw-mb-[150px] tw-w-full tw-max-w-[728px] tw-px-16">
        <BlogTitleAndAuthorDetails />
        <BlogHtmlContent htmlData={blogData?.html_data} />
      </div>
      {specificThemeRender(storeInfo)?.components?.Footer?.map((layout) => {
        return getThemeComponent(layout.sub_type, layout.name, {
          storeData: storeInfo,
          categories: catalogCategories || [],
          ...layout,
        });
      })}
    </>
  );
};

export default BlogPage;
